"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SSRLogger = /** @class */ (function () {
    function SSRLogger() {
        var _this = this;
        this.buffer = [];
        this.pushToBuffer = function (method) { return function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            // SSR logging should only be used in dev
            if (process.env.NODE_ENV !== 'development') {
                return;
            }
            _this.buffer.push({
                method: method,
                params: params,
            });
        }; };
        this.getServerSideLogs = function (flush) {
            if (flush === void 0) { flush = true; }
            // SSR logging should only be used in dev
            if (process.env.NODE_ENV !== 'development') {
                return [];
            }
            var buffer = _this.buffer;
            if (flush) {
                _this.buffer = [];
            }
            return buffer;
        };
        this.error = this.pushToBuffer('error');
        this.warn = this.pushToBuffer('warn');
        this.info = this.pushToBuffer('info');
        this.log = this.pushToBuffer('log');
        this.trace = this.pushToBuffer('trace');
    }
    return SSRLogger;
}());
exports.SSRLogger = SSRLogger;
//# sourceMappingURL=logger.js.map